// Validaciones de contraseña (plan.md §1.6/§2). Devuelven CÓDIGOS, nunca texto: la spec mezcla
// mensajes i18n (UC-4) y hardcodeados en español (UC-2/UC-3, C-1) — el mapeo código→texto es
// responsabilidad de application/presentation (constitution.md regla #2: domain/ no conoce i18n).

export type PasswordErrorCode = 'missingToken' | 'required' | 'tooShort' | 'mismatch';

export interface PasswordChangeInput {
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
}

export interface PasswordResetInput {
  token: string | null;
  newPassword: string;
  confirmPassword: string;
}

export const MIN_PASSWORD_LENGTH = 8;

/** UC-1: validación local del login — vacíos tras trim() bloquean el submit. */
export function validateLoginInput(username: string, password: string): boolean {
  return username.trim() !== '' && password.trim() !== '';
}

/** UC-4: orden exacto — campos vacíos → longitud mínima → coincidencia. */
export function validatePasswordChange(input: PasswordChangeInput): PasswordErrorCode | null {
  if (!input.currentPassword || !input.newPassword || !input.confirmPassword) {
    return 'required';
  }
  if (input.newPassword.length < MIN_PASSWORD_LENGTH) {
    return 'tooShort';
  }
  if (input.newPassword !== input.confirmPassword) {
    return 'mismatch';
  }
  return null;
}

/** UC-3: orden exacto — falta token → campos vacíos (trim) → longitud mínima → coincidencia. */
export function validatePasswordReset(input: PasswordResetInput): PasswordErrorCode | null {
  if (!input.token) {
    return 'missingToken';
  }
  if (!input.newPassword.trim() || !input.confirmPassword.trim()) {
    return 'required';
  }
  if (input.newPassword.length < MIN_PASSWORD_LENGTH) {
    return 'tooShort';
  }
  if (input.newPassword !== input.confirmPassword) {
    return 'mismatch';
  }
  return null;
}
